// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"Page404_buttonWrapper__jzisk"};